<template>
  <svg :x="x" :y="y" :width="`${widthInInches}in`" :height="`${heightInInches}in`" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern
        v-if="surfaceTextureUrl"
        :x="surfaceTexturePatternOrigin.x"
        :y="surfaceTexturePatternOrigin.y"
        :id="`${uuid}-mount-tile-pattern`"
        patternUnits="userSpaceOnUse"
        :width="fullBaseMat.surfaceTextureWidthInInches"
        :height="fullBaseMat.surfaceTextureHeightInInches"
      >
        <image
          :href="surfaceTextureUrl"
          :width="fullBaseMat.surfaceTextureWidthInInches"
          :height="fullBaseMat.surfaceTextureHeightInInches"
          preserveAspectRatio="xMaxYMin"
        />
      </pattern>
    </defs>

    <rect
      :width="widthInInches"
      :height="heightInInches"
      :fill="mountColor"
    />
    <RenderSvgMatDecoration
      v-if="isFloated"
      :frameSpec="frameSpec"
      :artworkOpenings="artworkOpenings"
      :matWidth="widthInInches"
      :matHeight="heightInInches"
    />
  </svg>
</template>

<script>
import uuidv4 from "uuid/v4";
import RenderSvgMatDecoration from "./RenderSvgMatDecoration.vue";

export default {
  components: {
    RenderSvgMatDecoration
  },
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    widthInInches: {
      type: Number,
      required: true
    },
    heightInInches: {
      type: Number,
      required: true
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    uuid() {
      return uuidv4();
    },
    fullBaseMat () {
      return this.frameSpec.getFullBaseMat();
    },
    surfaceTextureUrl () {
      return this.fullBaseMat?.surfaceTextureUrl;
    },
    mountColor() {
      if (!this.fullBaseMat) {
        return 'white';
      } else if (this.fullBaseMat?.surfaceTextureUrl) {
        return `url(#${this.uuid}-mount-tile-pattern)`;
      } else {
        return this.fullBaseMat.surfaceColor || 'transparent';
      }
    },
    artworkOpenings() {
      const reveal = this.frameSpec.mount.reveal;
      if (!reveal) return [];

      const artworkWidth = this.widthInInches - reveal.leftInInches - reveal.rightInInches;
      const artworkHeight = this.heightInInches - reveal.topInInches - reveal.bottomInInches;

      return [{
        key: 0,
        x: reveal.leftInInches,
        y: reveal.topInInches,
        width: artworkWidth,
        height: artworkHeight,
        bevelX: reveal.leftInInches,
        bevelY: reveal.topInInches,
        bevelWidth: artworkWidth,
        bevelHeight: artworkHeight,
      }];
    },
    surfaceTexturePatternOrigin () {
      if (!this.fullBaseMat.surfaceTextureWidthInInches || !this.fullBaseMat.surfaceTextureHeightInInches) {
        return { x: 0, y: 0 };
      }

      return {
        x: (this.widthInInches - this.fullBaseMat.surfaceTextureWidthInInches) / 2,
        y: (this.heightInInches - this.fullBaseMat.surfaceTextureHeightInInches) / 2
      };
    },
    isFloated() {
      return this.frameSpec.isFloated();
    },
  },
};
</script>

<style scoped>
/* No styles needed */
</style>
